import PropTypes from 'prop-types'
import styled from 'styled-components'
import loader from '../../assets/images/loader.gif'

const Container = styled.div`
  text-align: center;
`
const InlineLoader = ({ style }) => (
  <Container>
    <img src={loader} style={style} alt="Loading" />
  </Container>
)

InlineLoader.propTypes = { style: PropTypes.object }

export default InlineLoader
